import React from "react";
import BaseComponent from 'Core/components/BaseComponent';
import PropTypes from "prop-types";
import {BUTTON_DISPLAY_TYPE, BUTTON_STYLE} from 'Core/components/display/Button';
import {getArray} from 'Core/helpers/data';
import RadioInput from 'Core/components/input/RadioInput';

class FormRadioInput extends BaseComponent {
	constructor(props) {
		super(props, {
			optimizedUpdate: true,
			optimizedUpdateIgnoreProps: ['onChange'],
		});
	}
	
	render() {
		const {
			/** @type {FormQuestionDataObject} */
			data, ...otherProps
		} = this.props;
		
		return (
			<RadioInput
				isClearable={!data.mandatory}
				clearValue={null}
				buttonProps={{
					displayStyle: BUTTON_STYLE.DEFAULT,
					displayType: BUTTON_DISPLAY_TYPE.NONE,
				}}
				options={getArray(data, 'answers').map(a => ({label: a.content, value: a.id}))}
				{...otherProps}
			/>
		);
	}
}

/**
 * Define component's own props that can be passed to it by parent components
 */
FormRadioInput.propTypes = {
	// Question form element data
	// @type {FormQuestionDataObject}
	data: PropTypes.object,
	// Selected value (usually by the user) that will be submitted
	value: PropTypes.any,
	// Event triggered when input component value is changed (usually by the user)
	// @type {function(array(string|number))}
	onChange: PropTypes.func,
};

/**
 * Define component default values for own props
 */
FormRadioInput.defaultProps = {
	
};

export default FormRadioInput;